import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/contract/$contractid/edit")({
	component: RouteComponent
});

function RouteComponent() {
	return <div>Hello "/vendor/contract/$contractid/edit"!</div>;
}
